/** ownerInfo 是否仍需进入 /welcome 收集 nick_name */
export function ownerNeedsWelcomeNickName(
  ownerInfo: { nick_name?: string | null } | null | undefined,
): boolean {
  const trimmed = ownerInfo?.nick_name?.trim();
  return !trimmed;
}

/** 登录后 entry gate 可否依据 ownerInfo 做 nick_name 判断 */
export function isOwnerProfileReadyForEntryGate(
  profileState?: string,
): boolean {
  return profileState === "hasProfile" || profileState === "error";
}
